import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormForeignState } from './types';

export const transformDataset = (values: FiltersFormForeignState): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    sigla: {
      value: otherValues.acronym,
      operation: Operation.EQUALS,
    },
    codice: {
      value: otherValues.code,
      operation: Operation.LIKE,
    },
    nome: {
      value: otherValues.name,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    sigla: ordersToTransform.acronym,
    nome: ordersToTransform.name,
    codice: ordersToTransform.code,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
